import { render, staticRenderFns } from "./BlacklistModal.vue?vue&type=template&id=8c267834&scoped=true"
import script from "./BlacklistModal.vue?vue&type=script&lang=js"
export * from "./BlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c267834",
  null
  
)

export default component.exports